import { IssueTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { IssueLocationOnMap } from 'shared/domain/issue/issueLocationOnMap';

const ISSUE_LOCATION_ON_MAP_LABEL_KEYS: Record<IssueLocationOnMap, TranslationKey> = {
  [IssueLocationOnMap.notLocated]: IssueTranslationKeys.mapNotLocated,
  [IssueLocationOnMap.onCurrentVersion]: IssueTranslationKeys.mapLocatedOnCurrentVersion,
  [IssueLocationOnMap.onOtherVersion]: IssueTranslationKeys.mapLocatedOnOtherVersion,
  [IssueLocationOnMap.onWithdrawnVersion]: IssueTranslationKeys.mapLocatedOnWithdrawnVersion,
  [IssueLocationOnMap.onPreviousMap]: IssueTranslationKeys.mapLocatedOnPreviousMap,
};

/** Where the issue was located against its level's current map, as the map section tells it (PT-7117). */
export function issueLocationOnMapLabelKey(locationOnMap: IssueLocationOnMap): TranslationKey {
  return ISSUE_LOCATION_ON_MAP_LABEL_KEYS[locationOnMap];
}
